var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4 -4 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 4C1.5 3.72386 1.72386 3.5 2 3.5H14C14.2761 3.5 14.5 3.72386 14.5 4C14.5 4.27614 14.2761 4.5 14 4.5H2C1.72386 4.5 1.5 4.27614 1.5 4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66668 1.83331C6.44566 1.83331 6.2337 1.92111 6.07742 2.07739C5.92114 2.23367 5.83334 2.44563 5.83334 2.66665V3.49998H10.1667V2.66665C10.1667 2.44563 10.0789 2.23367 9.9226 2.07739C9.76632 1.92111 9.55436 1.83331 9.33334 1.83331H6.66668ZM11.1667 3.49998V2.66665C11.1667 2.18042 10.9735 1.7141 10.6297 1.37028C10.2859 1.02647 9.81957 0.833313 9.33334 0.833313H6.66668C6.18045 0.833313 5.71413 1.02647 5.37031 1.37028C5.0265 1.7141 4.83334 2.18042 4.83334 2.66665V3.49998H3.33334C3.0572 3.49998 2.83334 3.72384 2.83334 3.99998V13.3333C2.83334 13.8195 3.0265 14.2859 3.37031 14.6297C3.71413 14.9735 4.18045 15.1666 4.66668 15.1666H11.3333C11.8196 15.1666 12.2859 14.9735 12.6297 14.6297C12.9735 14.2859 13.1667 13.8195 13.1667 13.3333V3.99998C13.1667 3.72384 12.9428 3.49998 12.6667 3.49998H11.1667ZM3.83334 4.49998V13.3333C3.83334 13.5543 3.92114 13.7663 4.07742 13.9226C4.2337 14.0788 4.44566 14.1666 4.66668 14.1666H11.3333C11.5544 14.1666 11.7663 14.0788 11.9226 13.9226C12.0789 13.7663 12.1667 13.5543 12.1667 13.3333V4.49998H3.83334Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66666 6.83331C6.9428 6.83331 7.16666 7.05717 7.16666 7.33331V11.3333C7.16666 11.6095 6.9428 11.8333 6.66666 11.8333C6.39051 11.8333 6.16666 11.6095 6.16666 11.3333V7.33331C6.16666 7.05717 6.39051 6.83331 6.66666 6.83331Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33334 6.83331C9.60949 6.83331 9.83334 7.05717 9.83334 7.33331V11.3333C9.83334 11.6095 9.60949 11.8333 9.33334 11.8333C9.0572 11.8333 8.83334 11.6095 8.83334 11.3333V7.33331C8.83334 7.05717 9.0572 6.83331 9.33334 6.83331Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/delete.4bc0c2c5.svg";
export { ForwardRef as ReactComponent };